import MiniSearch, { SearchResult } from 'minisearch';

let miniSearch: MiniSearch;

/**
 * @param indexUrl An url where to find the search index json
 * @param primaryFields An array of fieldnames to search, these fields will be boosted
 * @param secondaryFields An array of fieldnames to search
 * @param storeFields An array of fieldnames to return as search result
 * @param combineWith The operand to combine partial results for each term. By default it is "AND", so only results matching all the search terms are returned by a search. If "OR" is given, results matching any of the search terms are returned by a search.
 * @param fuzzy Controls whether to perform fuzzy search. If a number higher or equal to 1 is given, fuzzy search is performed, with a maximum edit distance (Levenshtein) equal to the number. If a number between 0 and 1 is given, fuzzy search is performed within a maximum edit distance corresponding to that fraction of the term length, approximated to the nearest integer. For example, 0.2 would mean an edit distance of 20% of the term length, so 1 character in a 5-characters term. (default .5)
 * @param prefix Controls whether to perform prefix search (default true)
 */
const initSearch = (
    indexUrl: string,
    primaryFields: string[],
    secondaryFields: string[],
    storeFields: string[],
    combineWith: 'AND' | 'OR' = 'AND',
    fuzzy = 0.5,
    prefix = true
): void => {
    miniSearch = new MiniSearch({
        fields: [...primaryFields, ...secondaryFields],
        idField: 'url',
        storeFields,
        searchOptions: {
            fuzzy,
            prefix,
            combineWith,
            boost: primaryFields.reduce(
                (boost, primaryfield, currentIndex): { [key: string]: number } => ({
                    ...boost,
                    [primaryfield]: currentIndex
                }),
                {}
            )
        }
    });

    fetch(new Request(indexUrl))
        .then((response: Response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.blob();
        })
        .then((response: Blob) => response.text())
        .then((text: string): void => {
            miniSearch.addAll(JSON.parse(text));
        });
};

const executeSearch = (query: string): SearchResult[] => {
    return miniSearch.search(query);
};

export { initSearch, executeSearch };
